<template>
  <svg
    :class="customStyle"
    class="ml-1 h-4 w-4"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
</template>

<script>
export default {
  name: 'InfoRoundedIcon',
  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
